export default __webpack_public_path__ + "media/flags/rs-3e516456.svg";